import React from "react";

import img1 from "../img/I am this Hum between meat machines&&Postcards from the edge---Adobe Photoshop experiments with different patterns and textures over AI generated images___2025-11[[2]].jpg"

export default function Machine_3_4() {
  return (
    <div className="panel-block">

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="3.4 · POSTCARDS FROM THE EDGE"
        />
      </div>

      <div className="panel-container-right">
        <h2>3.4 · POSTCARDS FROM THE EDGE</h2>

      <p>
    Brief transmissions<br />
    signed by Vakzthar[11].
  </p>

  <p>
    Poetry.<br />
    Short fables.<br />
    Compressed truths.
  </p>

  <p>
    Not always connected.<br />
    Not always safe.
  </p>

  <p>
    Some edges are internal.
  </p>

    <p><a  target="_blank"  rel="noreferrer"  href="https://thevakztharimachine.substack.com/s/the-vakzthar11-postcards-from-the">Read it here</a></p>
     

  
      </div>

    </div>
  );
}
